// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm icons:create to update
// Do not edit
import type { SVGProps } from 'react';

export const IconBuildingSvg = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 20a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1ZM6 10a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 10a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v10a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V10Zm6 0h-4v9h4v-9ZM6 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4Zm10 0H5v15h8V4Z"
      clipRule="evenodd"
    />
  </svg>
);
